import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Button, CircularProgress, Tooltip, Typography } from '@mui/material';

interface InformeParcialCardProps {
  hayAnalisis: boolean;
  isFetching: boolean;
  onVerDescargar: () => void;
}

export function InformeParcialCard({
  hayAnalisis,
  isFetching,
  onVerDescargar,
}: InformeParcialCardProps): JSX.Element {
  return (
    <Box
      sx={{
        bgcolor: 'grey.100',
        border: '0.5px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <DescriptionOutlinedIcon
        sx={{ fontSize: 28, color: 'secondary.main', flexShrink: 0 }}
      />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" fontWeight={600} mb={0.5}>
          Informe parcial
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Se regenera cada vez. Reemplaza la versión anterior.
        </Typography>
      </Box>

      <Tooltip
        title={!hayAnalisis ? 'Cargá al menos un análisis para generar el informe' : ''}
      >
        <span>
          <Button
            variant="outlined"
            size="small"
            disabled={!hayAnalisis || isFetching}
            onClick={onVerDescargar}
            startIcon={
              isFetching ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <DownloadIcon />
              )
            }
            sx={{ flexShrink: 0 }}
          >
            {isFetching ? 'Generando...' : 'Ver / descargar'}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
